// The office line, shown wherever someone might be stuck (Support, and the
// sign-in and error screens, which work before anyone is signed in).
export const OFFICE_PHONE = '0330 043 2088';
export const OFFICE_TEL = 'tel:+443300432088';
